import { CartLinesUpdateEvent } from '@shopify/events';

const states = new WeakMap();
function setup(root) {
  if (states.has(root)) return;
  const start = Date.parse(root.dataset.start);
  const end = Date.parse(root.dataset.end);
  const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
  const loadedAt = Date.now();
  const milestones = root.dataset.nextEnabled === 'true' ? [Date.parse(root.dataset.reveal), Date.parse(root.dataset.nextStart)] : [];
  const state = { busy: false, valid, start, end };
  states.set(root, state);
  const permitted = () => valid && root.dataset.active === 'true' && root.dataset.available === 'true' && Date.now() >= start && Date.now() < end;
  const buttons = () => root.querySelectorAll('[data-drop-buy]');
  const update = () => {
    if (!state.busy && milestones.some(time => Number.isFinite(time) && time > loadedAt && Date.now() >= time)) { window.location.reload(); return; }
    const allowed = permitted();
    buttons().forEach(button => { button.disabled = !allowed || state.busy; });
    const remaining = Math.max(0, Math.floor((end - Date.now()) / 1000));
    if (valid) ['day','hour','minute','second'].forEach((unit,index) => { const node=root.querySelector('[data-drop-'+unit+']'); if(node) node.textContent=String([Math.floor(remaining/86400),Math.floor(remaining%86400/3600),Math.floor(remaining%3600/60),remaining%60][index]).padStart(2,'0'); });
    const countdown = root.querySelector('.fwd__countdown');
    if (countdown) countdown.hidden = !allowed;
    const status = root.querySelector('[data-drop-status]');
    if (status && (!valid || Date.now() >= end || Date.now() < start)) {
      status.hidden = false;
      status.textContent = Date.now() < start ? root.dataset.soon : root.dataset.ended;
    }
  };
  state.update = update;
  update();
  root.querySelector('[name="id"]')?.addEventListener('change', event => {
    const option = event.target.selectedOptions?.[0];
    if (!option) return;
    if (option.dataset.groupImage) {
      const image = root.querySelector('.fwd__image');
      if (image) { image.removeAttribute('srcset'); image.src = option.dataset.groupImage; image.alt = option.dataset.groupTitle; }
      const details = root.querySelector('.fwd__details');
      if (details) details.href = option.dataset.groupUrl;
      root.dataset.available = String(!option.disabled);
      update();
    }
    root.querySelectorAll('[data-drop-buy]').forEach(button => { button.textContent=(root.dataset.bogo === 'true' ? root.dataset.pairLabel+' '+option.dataset.title : root.dataset.addLabel)+' — '+option.dataset.price; });
    root.querySelectorAll('[data-drop-variant]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.dropVariant === option.value)));
    root.querySelectorAll('[data-drop-price]').forEach(node => { node.textContent = option.dataset.price; });
    let compare = root.querySelector('[data-drop-compare]');
    if (!compare) { compare = document.createElement('s'); compare.dataset.dropCompare = ''; root.querySelector('.fwd__price').append(compare); }
    compare.textContent = option.dataset.compare;
    compare.hidden = !option.dataset.compare;
  });
  root.querySelectorAll('[data-drop-image]').forEach(button => button.addEventListener('click', () => {
    const image = root.querySelector('.fwd__image');
    image.removeAttribute('srcset');
    image.src = button.dataset.dropImage;
    image.alt = button.dataset.alt;
    root.querySelectorAll('[data-drop-image]').forEach(node => node.setAttribute('aria-pressed', String(node === button)));
  }));
  root.querySelectorAll('[data-drop-variant]').forEach(button => button.addEventListener('click', () => { const select=root.querySelector('select[name="id"]'); select.value=button.dataset.dropVariant; select.dispatchEvent(new Event('change',{bubbles:true})); }));
  const dialog = root.querySelector('dialog');
  root.querySelector('[data-drop-zoom]')?.addEventListener('click', () => {
    const source = root.querySelector('.fwd__image');
    const full = root.querySelector('[data-drop-full]');
    full.src = source.currentSrc || source.src;
    full.alt = source.alt;
    dialog.showModal();
  });
  root.querySelector('[data-drop-close]')?.addEventListener('click', () => dialog.close());
  root.querySelector('.fwd__buy')?.addEventListener('submit', async event => {
    event.preventDefault();
    if (!permitted() || state.busy) return;
    state.busy = true;
    update();
    const form = event.currentTarget;
    const error = root.querySelector('[data-drop-error]');
    error.hidden = true;
    const data = new FormData(form);
    const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(node => node.dataset.sectionId))].slice(0, 5);
    if (sections.length) data.set('sections', sections.join(','));
    data.set('sections_url', window.location.pathname);
    const deferred = CartLinesUpdateEvent.createPromise();
    form.dispatchEvent(new CartLinesUpdateEvent({ action: 'add', context: 'product', lines: [{ merchandiseId: String(data.get('id')), quantity: Number(data.get('quantity')) }], promise: deferred.promise }));
    let added = false;
    try {
      const base = window.Shopify.routes.root;
      const response = await fetch(base + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || result.message || root.dataset.error);
      added = true;
      const cartResponse = await fetch(base + 'cart.js', { headers: { Accept: 'application/json' } });
      if (!cartResponse.ok) throw new Error(root.dataset.error);
      const cart = await cartResponse.json();
      deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart), detail: { items: cart.items, sections: result.sections, source: 'weekly-drop', sourceId: form.id, itemCount: Number(data.get('quantity')), didError: false } });
      const drawer = document.querySelector('cart-drawer-component')?.closest('theme-drawer');
      if (drawer?.open) drawer.open();
      else window.location.assign(base + 'cart');
    } catch (failure) {
      deferred.reject(failure);
      if (added) {
        window.location.assign(window.Shopify.routes.root + 'cart');
      } else {
        error.hidden = false;
        error.textContent = failure.message || root.dataset.error;
      }
    } finally {
      state.busy = false;
      update();
    }
  });
}
function initialize() { document.querySelectorAll('[data-weekly-drop]').forEach(setup); }
initialize();
document.addEventListener('shopify:section:load', initialize);
setInterval(() => document.querySelectorAll('[data-weekly-drop]').forEach(root => states.get(root)?.update()), 1000);

